export default {
  START: 'start',
  STOP: 'stop',
  RESET: 'reset',
  TICK: 'tick',
  TO_TIME_CHANGED: 'to-time-changed',
  CURRENT_TIME_CHANGED: 'to-time-changed',
  TO_TIME_REACHED: 'to-time-reached',
};


// WEBPACK FOOTER //
// ./src/modules/dro/timer/Events.js